import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Link from 'components/common/Link/Link'
import { ServiceIcon } from 'components/common/ServiceIcon'

export const Info = styled.div`
  display: table-cell;
  width: 100%;
  vertical-align: middle;
  ${Mixin.responsive('padding-left', '10px', '16px')}
`

export const Price = styled.span`
  display: inline-block;
  margin: 0 6px 9px 0;
  color: ${Theme.colors.black};
  vertical-align: middle;
  ${Mixin.font.GothamBold(14)}
  ${props => props.small && css`
    font-weight: 400;
    color: ${Theme.colors.caption_grey};
  `}
`

export const Name = styled(Link)`
  display: inline-block;
  width: 100%;
  margin-bottom: 3px;
  line-height: 19px;
  vertical-align: middle;
  ${props => props.suggest && css`
    margin-bottom: 0;
    line-height: 22px;

    & + & {
      margin-top: 10px;
    }
  `}
`

export const Image = styled.img`
  display: table-cell;
  width: 136px;
  height: 136px;
  vertical-align: middle;
  ${Media.desktop`
    width: 100px;
    height: 100px;
  `}
`

export const CustomServiceIcon = styled(ServiceIcon)`
  display: table-cell;
  width: 136px;
  height: 136px;
  vertical-align: middle;
  border: 1px solid ${Theme.colors.light_grey};
  padding: 20px;
  ${Media.desktop`
    width: 100px;
    height: 100px;
  `}
`

export const Table = styled.div`
  display: table;
  width: 100%;
`

export const Block = styled.div`
  display: inline-block;

  & + & {
    margin-top: 10px;
  }
`
